export default __webpack_public_path__ + "static/media/3.912501a9.jpg";